// 액션 타입 정의
const TRACKING_RESET = 'TRACKING_RESET';
const CURRENT_BUTTON = 'CURRENT_BUTTON';
const TRACKING = 'TRACKING';
const BUTTON1 = 'BUTTON1';
const BUTTON2 = 'BUTTON2';
const LOG_CUSTOM = 'LOG_CUSTOM';
// 액션 생섬함수 정의
export const trackingReset = () => ({ type: TRACKING_RESET });
export const editCurrentButton = value => ({ type: CURRENT_BUTTON, value });
export const editTracking = value => ({ type: TRACKING, value });
export const editButton1 = value => ({ type: BUTTON1, value });
export const editButton2 = value => ({ type: BUTTON2, value });
export const editLogCustom = value => ({ type: LOG_CUSTOM, value });
// 초기상태 정의
const initialState = {
  currentButton: 0,
  tracking: {},
  button1: {},
  button2: {},
  logCustom: {}
};
// 리듀서 작성
export default function trackingReducer(state = initialState, action) {
  switch (action.type) {
    case TRACKING_RESET:
      return initialState;
    case CURRENT_BUTTON:
      return {
        ...state,
        currentButton: action.value
      };
    case TRACKING:
      return {
        ...state,
        tracking: action.value
      };
    case BUTTON1:
      return {
        ...state,
        button1: action.value
      };
    case BUTTON2:
      return {
        ...state,
        button2: action.value
      };
    case LOG_CUSTOM:
      return {
        ...state,
        logCustom: action.value
      };
    default:
      return state;
  }
}
